
<template>
    <div>
        <v-tour name="myTour" :steps="steps" :callbacks="callbacks">
            <template slot-scope="tour">
                <transition name="fade">
                    <v-step
                            v-if="tour.currentStep === index"
                            v-for="(step, index) of tour.steps"
                            :key="index"
                            :step="step"
                            :previous-step="tour.previousStep"
                            :next-step="tour.nextStep"
                            :stop="stop"
                            :is-first="tour.isFirst"
                            :is-last="tour.isLast"
                            :labels="tour.labels"
                    >
                        <!--<template v-if="index === Object.keys(steps).length - 1">-->
                            <!--<div slot="actions">-->
                                <!--<button @click="tour.previousStep" class="btn btn-primary mr-2">Previous step</button>-->
                                <!--<button @click="tour.nextStep" class="btn btn-primary">Next step</button>-->
                            <!--</div>-->
                        <!--</template>-->
                    </v-step>
                </transition>
            </template>
        </v-tour>
    </div>
</template>

<script>
    export default {
        name: "HomeTour",
        data() {
            return {
                steps: [
                    {
                        //0
                        target: '#v-step-0',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Lets get you started how to use Ainak Cloud</span>`
                    },
                    {
                        //1
                        target: '#v-step-0-1',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">These are your notifications</span>`
                    },
                    {
                        //2
                        target: '#v-step-0-2',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">All of your 3D models will be shown under this tab</span>`,
                        params: {
                            placement: 'left'
                        }
                    },
                    {
                        //3
                        target: '#v-step-0-3',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">You can upload models by going in this tab</span>`,
                        params: {
                            placement: 'right'
                        }
                    },
                    {
                        //4
                        target: '#v-step-0-4',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Click here or drop files to upload</span>`,
                        params: {
                            placement: 'left'
                        }
                    },
                    {
                        //5
                        target: '#v-step-0-4',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Click here or drop files to upload</span>`,
                        params: {
                            placement: 'left'
                        }
                    },
                    {
                        //6
                        target: '#v-step-0-5',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Here you will see the name of the selected file with realtime upload progress</span>`,
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        //7
                        target: '#v-step-0-6',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Add a common description of the current selected files</span>`,
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        //8
                        target: '#v-step-0-7',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Check if the current models are available on app or not</span>`,
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        //9
                        target: '#v-step-0-8',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">You can cancel the upload if changed your mind</span>`,
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        //10
                        target: '.btn-upload',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Click to upload all the selected models to the server</span>`,
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        //11
                        target: '.upload-files-selected',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Uploading</span>`,
                        params: {
                            placement: 'left'
                        }
                    },
                    {
                        //12
                        target: '#v-step-0-2',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Your uploaded models are listed here</span>`,
                        params: {
                            placement: 'left'
                        }
                    },
                    {
                        //13
                        target: '#v-step-0-13',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;">Here you can Download, Edit and Delete models</span>`,
                        params: {
                            placement: 'bottom'
                        }
                    },
                    {
                        //14
                        target: '#v-step-0',
                        content: `<span style="color: white; font-family: 'Roboto', sans-serif;"><i class="em em-clap"></i> Great!! you have finished the tutorial</span>`
                    }
                ],
                callbacks: {
                    onPreviousStep: this.myCustomPreviousStepCallback,
                    onNextStep: this.myCustomNextStepCallback
                }
            }
        },
        mounted: function () {
            // this.$tours['myTour'].start()
            // A dynamically added onStop callback
            this.callbacks.onStop = () => {
                document.querySelector('#v-step-0').scrollIntoView({behavior: 'smooth'})
            }
        },
        methods: {
            nextStep() {
                this.$tours['myTour'].nextStep()
            },
            showLastStep() {
                this.$tours['myTour'].currentStep = this.steps.length - 1
            },
            myCustomPreviousStepCallback(currentStep) {
                console.log(' previous current Step ' + (currentStep));

                if (currentStep === 3) {
                    this.$store.dispatch('setCurrentTab', 0)
                }
            },
            myCustomNextStepCallback(currentStep) {


                console.log('current Step ' + (currentStep));

                if (currentStep === 2) {
                    this.$store.dispatch('setCurrentTab', 1)
                }

                if (currentStep === 4) {
                    document.getElementById('upload-file-control').click();
                }

                if (currentStep === 10) {
                    document.getElementById('btn-upload-id').click();
                }
            },
            stop() {
                console.log("Tut stop  called!!");
                this.$tours['myTour'].stop();
                this.$store.dispatch('stopTutorial');

                let payload = {
                    "first_login": false
                };
                this.$store.dispatch('updateFirstLogin', payload)
                    .then(() => {
                        console.log("hurry");
                    }).catch(() => {

                    console.log("no hurry");
                });

            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>